import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SERVICES, BRAND } from '../data/mock';
import { useQuote } from '../context/QuoteContext';
import SectionHeading from './SectionHeading';

const Services = () => {
  const { openQuote } = useQuote();
  return (
    <section id="services" className="section-pad bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="What We Do"
          title="Services We"
          accent="Offer"
          subtitle="From baraat swagat to boardrooms — we bring the freshest, most Instagram-worthy coconut moments to every kind of event."
        />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              className="coco-card group relative overflow-hidden rounded-3xl bg-white border border-pink-100 shadow-soft"
              style={{ animationDelay: `${i * 60}ms` }}
              data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-blush">
                <img
                  src={s.image}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
                <span className="absolute top-4 left-4 inline-flex items-center gap-1 bg-white/95 text-pink-brand text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded-full shadow-sm">
                  {s.tag}
                </span>
              </div>
              <div className="p-6">
                <h3 className="font-display font-semibold text-xl text-stone-900 leading-tight">{s.title}</h3>
                <div className="mt-4 flex items-center gap-3">
                  <button
                    onClick={() => openQuote({ event_type: s.tag === 'Wedding' ? 'Wedding Ceremony' : s.title, source: `service-${s.tag.toLowerCase()}` })}
                    className="inline-flex items-center gap-1 text-sm font-semibold text-pink-brand hover:gap-2 transition-all"
                    data-testid={`service-${s.tag.toLowerCase()}-quote-button`}
                  >
                    Get a Quote <ArrowRight className="w-3.5 h-3.5" />
                  </button>
                  <span className="w-px h-4 bg-stone-200" />
                  <a
                    href={`https://wa.me/${BRAND.phoneRaw}`}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1 text-sm text-stone-500 hover:text-stone-900 transition-colors"
                  >
                    Read more <ArrowRight className="w-3.5 h-3.5" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
